var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.eventTypeCss},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('ul',[_c('li',[_vm._v(" "+_vm._s(_vm.startTime)+" "),_c('span',[_vm._v(_vm._s(_vm.patientName))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }